import Util from '@/util';
import callChannelType from '@/constants/callChannelType';
import { store } from '@/store/store';
import eventBus from '@/EventBus';

import initNeomecca from '@/util/call/neomecca/initNeomecca';
import initKt from '@/util/call/kt/initKt';
import initKlcns from '@/util/call/klcns/initKlcns';
import initNeoWebRtc from '@/util/call/neoWebRTC/initNeoWebRtc';

async function initCall() {
  // 멀티브랜드에서는 상담사에게 할당된 브랜드들 중 콜 승인완료가 된 브랜드가 있을 경우, callServerType값이 내려옴.
  // 사용하지 않는 브랜드는 값이 없다.
  const callType = Util.getCallTypeFromToken();
  if (callType) {
    switch (callType) {
      case callChannelType.NEOMECCA:
        await initNeomecca.initNeomecca();
        break;
      case callChannelType.KT:
        await initKt.initKt();
        break;
      case callChannelType.KLCNS:
        await initKlcns.initKlcns();
        break;
      case callChannelType.NEO_WEB_RTC:
        await initNeoWebRtc.initNeoWebRtc();
        break;
    }
  } else {
    store.commit('changeIsExistCallAgent', false);
    eventBus.$emit('set-call-agent');
    store.commit('changeIsInitUi', true);
    store.commit('initDimmed');
  }
}

function connectCallSocket() {
  const callType = Util.getCallTypeFromToken();
  if (!callType) return;
  switch (callType) {
    case callChannelType.NEOMECCA:
      initNeomecca.connectCallSocket();
      break;
    case callChannelType.KT:
      initKt.connectCallSocket();
      break;
    case callChannelType.KLCNS:
      initKlcns.connectCallSocket();
      break;
    case callChannelType.NEO_WEB_RTC:
      initNeoWebRtc.connectCallSocket();
      break;
  }
}

function connectStatus() {
  const callType = Util.getCallTypeFromToken();
  if (!callType) return;
  switch (callType) {
    case callChannelType.KT:
      initKt.connectStatusSocket();
      break;
    case callChannelType.KLCNS:
      initKlcns.connectStatusSocket();
      break;
  }
}

function connectApi() {
  const callType = Util.getCallTypeFromToken();
  if (!callType) return;
  switch (callType) {
    case callChannelType.NEOMECCA:
      initNeomecca.connectApiSocket();
      break;
    case callChannelType.KT:
      initKt.connectApiSocket();
      break;
    case callChannelType.KLCNS:
      initKlcns.connectApiSocket();
      break;
    case callChannelType.NEO_WEB_RTC:
      initNeoWebRtc.connectApiSocket();
      break;
  }
}

export default {
  initCall,
  connectCallSocket,
  connectStatus,
  connectApi
};



// WEBPACK FOOTER //
// ./src/util/call/connectSocket.js